import createRoute   from '@widesk-ui/tools/createRoute';
import ShipmentModel from '@models/shop/ShipmentModel';

export default createRoute.splitView('/entertainments/:entertainmentId/shipments', 'shop', 'ShipmentSplitView', ShipmentModel.localize('plural'));